import React, { useMemo, useState } from 'react'
import './styles.scss'
import { aminoAcids } from '../aminoAcids.js'
import { usePctChange } from '../store'

export const ChainViewer = () => {
  const [pct, setPct] = useState(0)
  const chain = useMemo(() => {
    const segment = [
      'A',
      'Y',
      'T',
      'N',
      'S',
      'F',
      'T',
      'R',
      'G',
      'V',
      'Y',
      'Y',
      'P',
      'D',
      'K',
      'V',
      'F',
      'R',
      'S',
      'S',
      'V',
      'L',
      'H',
      'S',
      'T',
      'Q',
      'D',
      'L',
      'F',
      'L',
      'P',
      'F',
      'F',
      'S',
      'N',
      'V',
      'T',
      'W',
      'F',
      'H',
      'A',
      'I',
      'H'
    ]

    return segment.map(aminoAcid => aminoAcids.find(a => a.code === aminoAcid))
  }, [])

  usePctChange(pct => {
    setPct(pct)
  })

  // console.log(pct)

  return (
    <div className='chain-viewer'>
      <div className='chain-slider-container'>
        <div className='chain-slider' style={{ width: `${pct * 100}%` }} />
      </div>
      <div className='chain'>
        {chain.slice(0, Math.floor(50 * pct)).map((aminoAcid, i) => {
          return (
            <div key={i} className='aminoacid'>
              <div className='aminoacid-seq'>{i + 46}</div>
              <div className='aminoacid-code'>{aminoAcid.code}</div>
            </div>
          )
        })}
      </div>
      Continuez à scroller...
    </div>
  )
}
